
import styled, { keyframes } from 'styled-components';
import { ReactComponent as LogoImg } from "../../assets/images/NFA.svg";

const Pulsate = keyframes`
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.6);
  };

  25% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.4);
  };
  50% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  };

  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
  };
  `

const Container = styled.div`
width:100%;
height: 100vh;
background: #EFF2F3;
position: fixed;
top: 0;
z-index: 10;
display: flex;
align-items: center;
justify-content:  center;
flex-direction: column;

svg{
  animation: ${Pulsate} 3s infinite;
}

`

const LazyLoader = () => {
  return (
    <Container>

      <LogoImg />

    </Container>
  )
}

export default LazyLoader;